module.exports = __webpack_public_path__ + "media/intro_video.8c118084.mp4";